import React, { useState, useEffect, useRef } from "react";
import { Menu, Box, Typography, IconButton, Backdrop, Button } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const IButtonModal = ({ type, element, anchorEl, setAnchorEl }) => {
  const theme = useTheme();
  const open = Boolean(anchorEl);

  const [showFull, setShowFull] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (open) {
      setShowFull(false);
      // Wait a tick for the DOM to render the HTML before measuring
      setTimeout(() => {
        if (contentRef.current) {
          setIsOverflowing(contentRef.current.scrollHeight > 300);
        }
      }, 50);
    }
  }, [open, element]);

  return (
    <>
      <Backdrop
        open={open}
        sx={{
          zIndex: theme.zIndex.modal - 1,
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
        onClick={() => setAnchorEl(null)}
      />

      <Menu
        id="account-menu"
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          elevation: 3,
          sx: {
            overflow: "visible",
            width: "90%",
            maxWidth: "400px",
            height: "auto",
            maxHeight: "80vh",
            position: "absolute",
            top: "50%",
            left: "50%",
            padding: "20px",
            transform: "translate(-50%, -50%)",
            borderRadius: "10px",
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[10],
            [theme.breakpoints.down("sm")]: {
              padding: "10px",
            },
          },
        }}
        transformOrigin={{
          horizontal: "center",
          vertical: "center",
        }}
        anchorOrigin={{
          horizontal: "center",
          vertical: "center",
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            size="small"
            onClick={() => setAnchorEl(null)}
            sx={{
              position: "absolute",
              top: "-45px",
              right: "-35px",
              backgroundColor: "primary.light",
              zIndex: 2,
              [theme.breakpoints.down("sm")]: {
                top: "5px",
                right: "5px",
                position: "absolute",
                backgroundColor: "primary.main",
                color: "white",
              },
            }}
          >
            <Close />
          </IconButton>
          <Box
            sx={{
              width: "100%",
              height: "auto",
              overflowY: "auto",
              borderRadius: "5px",
            }}
          >
            {type === "img" ? (
              <Box
                component="img"
                src={element}
                alt="preview"
                sx={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  objectFit: "contain",
                  display: "block",
                  [theme.breakpoints.down("sm")]: {
                    maxHeight: "70vh",
                  },
                }}
              />
            ) : type === "html" ? (
              <Box>
                <Box
                  ref={contentRef}
                  sx={{
                    maxHeight: showFull ? "none" : "300px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: element }} />
                  {isOverflowing && !showFull && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "80px",
                        background: `linear-gradient(to bottom, transparent, ${theme.palette.background.paper})`,
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </Box>
                {isOverflowing && !showFull && (
                  <Button
                    fullWidth
                    variant="text"
                    onClick={() => setShowFull(true)}
                    sx={{ mt: 1, textTransform: "none", fontWeight: "bold" }}
                  >
                    Show More
                  </Button>
                )}
              </Box>
            ) : (
              <Typography variant="body1">{element}</Typography>
            )}
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default IButtonModal;
